import type { FormEvent } from 'react';
import type { FreeStatus } from '../types';
import FreeSection    from './FreeSection';
import VoucherSection from './VoucherSection';

interface Props {
  phase:           string;
  free:            FreeStatus;
  errMsg:          string;
  voucher:         string;
  codeFromQR:      boolean;
  onVoucherChange: (v: string) => void;
  onConnect:       () => void;
  onSubmit:        (e: FormEvent) => void;
  onShowTerms:     () => void;
  onShowPrivacy:   () => void;
}

const PortalCard = ({ phase, free, errMsg, voucher, codeFromQR, onVoucherChange, onConnect, onSubmit, onShowTerms, onShowPrivacy }: Props) => (
  <div className="card">
    <div className="brand">TAPETE&nbsp;<span className="brand-dot">.nett</span></div>
    <p className="tagline">Willkommen bei TAPETE .nett! 🤗</p>

    {!codeFromQR && <FreeSection phase={phase} free={free} errMsg={errMsg} onConnect={onConnect} />}
    {!codeFromQR && <div className="divider"><span>oder mit Zugangscode</span></div>}

    <VoucherSection
      phase={phase}
      voucher={voucher}
      codeFromQR={codeFromQR}
      onVoucherChange={onVoucherChange}
      errMsg={errMsg}
      onSubmit={onSubmit}
    />

    <p className="legal-notice">
      Mit dem Verbinden akzeptierst du die{' '}
      <button className="link-btn" type="button" onClick={onShowTerms}>Nutzungsbedingungen</button>
      {' '}und nimmst den{' '}
      <button className="link-btn" type="button" onClick={onShowPrivacy}>Datenschutzhinweis</button>
      {' '}zur Kenntnis.
    </p>
    <p className="help">Bei Problemen wende dich ans Personal.</p>
  </div>
);

export default PortalCard;
